import React from 'react';
import './ForecastStrip.css';

const REQUIRED_CHECKINS = 5;

const ForecastPlaceholder = ({ checkinCount = 0 }) => {
  const safeCount = Math.max(0, Math.min(Number(checkinCount) || 0, REQUIRED_CHECKINS));
  const progress = (safeCount / REQUIRED_CHECKINS) * 100;

  return (
    <section className="forecast-card" aria-label="Seven day forecast locked">
      <div className="forecast-card__header">
        <div>
          <h2 className="forecast-card__title">Seven day forecast</h2>
          <p className="forecast-card__subtitle">
            Unlock your forecast after five saved check-ins.
          </p>
        </div>
        <span className="forecast-card__count">
          {safeCount} of {REQUIRED_CHECKINS}
        </span>
      </div>

      <div className="forecast-placeholder__track" aria-hidden="true">
        <span
          className="forecast-placeholder__fill"
          style={{ width: `${progress}%` }}
        />
      </div>

      <p className="forecast-placeholder__text">
        Save more check-in results so QuitPact can learn your weekday pattern.
      </p>
    </section>
  );
};

export default ForecastPlaceholder;
